// extracted by mini-css-extract-plugin
module.exports = {"form":"styles_form__3DIWC","row":"styles_row__2KRD6"};